<ion-list mode="ios" lines="none" class="list-content">
  <!-- ? Titulo -->
  <ion-item lines="none" mode="md" color="white" class="ion-text-center">
    <ion-label mode="md" color="status-icon-enable" class="mpe-font-weight-600">
      {{ 'Titles.client-data' | translate }}
    </ion-label>
  </ion-item>

  <!-- * Descripción -->
  <ion-item
    lines="none"
    mode="md"
    color="white"
    class="ion-text-center item-locate-ticket"
  >
    <ion-label
      mode="md"
      color="status-icon-enable"
      class="mpe-font-weight-600 locate-ticket"
    >
      {{ 'Labels.locate-your-delivery-ticket' | translate }}
      <p class="image-shown-reference">
        <ion-text
          color="cadet-grey"
          [innerHTML]="'Labels.image-shown-reference' | translate"
        >
        </ion-text>
      </p>
    </ion-label>
  </ion-item>

  <!-- ? Imagen Ticket -->
  <ion-item lines="none" mode="md" color="white">
    <ion-img
      [src]="'Icons.ticket-data-user' | translate"
      class="img-ticket-user"
    ></ion-img>
  </ion-item>

  <!-- ? Imagen Ticket -->
  <ion-item lines="none" mode="md" color="white" class="ion-text-center">
    <ion-label
      mode="md"
      color="status-icon-enable"
      class="additional-help-consult-preventista"
      [innerHTML]="'Labels.additional-help-consult-preventista' | translate"
    ></ion-label>
  </ion-item>

  <!-- ? Boton de aceptar -->
  <ion-item lines="none" mode="md" color="white">
    <ion-button
      class="button-accept"
      size="default"
      mode="md"
      color="tpcta"
      (click)="onAccept()"
    >
      <ion-label mode="md" class="mpe-font-weight-600">
        {{ 'Buttons.accept' | translate }}
      </ion-label>
    </ion-button>
  </ion-item>
</ion-list>
